import { render, staticRenderFns } from "./RestaurantDetail.vue?vue&type=template&id=a0fad74c&scoped=true&"
import script from "./RestaurantDetail.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetail.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDetail.vue?vue&type=style&index=0&id=a0fad74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fad74c",
  null
  
)

export default component.exports